import React from 'react';

export default class WorksheetAnswers extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  createAnswers() {
    return this.props.problems.map((prob, index) => {
      return (
        <div className="worksheets__answer" key={index}>
          <span className="worksheets__answer-index">{index+1}</span>
          <span className="worksheets__answer-value">{prob[0]}</span>
        </div>
      );
    });
  }

  render() {
    const answers = this.createAnswers();
    return (
      <div className="worksheets__answers">
        <h1 className="worksheets__answers-heading">Answer Sheet</h1>
        {answers}
      </div>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/worksheets/worksheet-answers.js
 **/